import { UtcDate } from '@/helpers/date';
import { parseCompareDate } from '@/validation/utils';

export default {
  validate: (value, { compare, equal }) => {
    let valid = false;

    if (
      ['', null, undefined].includes(value) ||
      ['', null, undefined].includes(compare)
    ) {
      return {
        valid: false,
        required: true,
      };
    }

    const valueDate = new UtcDate(value);
    const dateToCompare = parseCompareDate(compare);

    if (equal && valueDate.isEqual(dateToCompare)) valid = true;

    if (valueDate.isBefore(dateToCompare)) valid = true;

    return {
      valid,
      required: true,
    };
  },
  params: ['compare', 'equal'],
  computesRequired: true,
};
